import React from 'react';

import { PrivateBadge } from '@pkg/components/Sections/Groups/GroupHeader/Badges/PrivateBadge';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { Sizes } from '@pkg/components/Sections/Profile/Buttons/Button/types';

import { type IWishlist } from '@app/client/common/structs/wishlists/wishlists';

import { WishlistThumbnail } from '../WishlistThumbnail';

import {
    EndWrapper,
    InfoWrapper,
    Radio,
    WishlistItemInner,
    WishlistItemNumber,
    WishlistItemWrapper,
    WishlistName,
} from './styles';

interface WishlistItemCardProps extends IWishlist {
    activeSlug?: string;
    isDefault?: boolean;
    onConfirm?(): void;
    canMove?: boolean;
    isMoving?: boolean;
}

export const WishlistItemCard = ({
    slug,
    name,
    counts,
    private: isPrivate,
    activeSlug,
    isDefault,
    onConfirm,
    items,
    isMoving,
}: WishlistItemCardProps) => {
    return (
        <WishlistItemWrapper $isDefault={isDefault}>
            <WishlistThumbnail isSmall items={items} />
            <WishlistItemInner>
                <WishlistName target="_blank" rel="noopener noreferrer" href={`/wishlists/${slug}`}>
                    {name}
                </WishlistName>
                <InfoWrapper>
                    <WishlistItemNumber>{counts.total} items</WishlistItemNumber>
                    {isPrivate && <PrivateBadge text={`Private`} bgColor={'#312440'} />}
                </InfoWrapper>
            </WishlistItemInner>
            <EndWrapper>
                {isDefault && (
                    <Radio>
                        <div />
                    </Radio>
                )}
                {!isDefault ? (
                    <Button onClick={onConfirm} size={Sizes.small} loading={isMoving && activeSlug === slug}>
                        Move
                    </Button>
                ) : null}
            </EndWrapper>
        </WishlistItemWrapper>
    );
};
